export enum LossType {
    Disability = 'Disability',
    Life = 'Life',
    Accidental_Dismemberment = 'Accidental Dismemberment',
    Terminal_Illness = 'Terminal Illness',
    Unemployment = 'Involuntary Unemployment',
    Unemployment_Compatability_Format = 'Unemployment',
    Hospitalization = 'Hospitalization'
}